import * as React from 'react';

import { InvitesDialog } from './InvitesDialog';

interface WorkspaceInviteDialogProps {
  workspaceId: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}

/**
 * Invite dialog entry point. Renders the role-dropdown invite flow; reset and
 * disable happen inline within {@link InvitesDialog}'s per-role panel (no
 * separate confirmation overlays).
 */
export function WorkspaceInviteDialog({
  workspaceId,
  open,
  setOpen,
}: WorkspaceInviteDialogProps) {
  return (
    <InvitesDialog
      isOpen={open}
      handleClose={() => setOpen(false)}
      workspaceId={workspaceId}
    />
  );
}
